import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';
import {
  analyticsCtaDataObject,
  handleAdobeNavEvent,
  adobeCleanString,
} from '../../../helpers/adobe-analytics';
import '@Root/lib/lit-3form-block/components/cta-text';

export class Lisa extends Lit3formBlock {
  static get characterName() {
    return 'lisa';
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div id="lisa-block" class="block-grid lisa-layout">
          <div class="lisa-intro">
            <h2 class="lisa-header">${unsafeHTML(this.headerText)}</h2>
            <p class="lisa-description">${unsafeHTML(this.descriptionText)}</p>
          </div>
          <div class="lisa-grid">
            ${this.images.map(image => this.renderTile(image[1]))}
          </div>
        </div>
      </div>
    `;
  }

  renderTile(project) {
    return html`
      <div class="lisa-tile">
        <a
          class="lisa-tile-image"
          href="${project.url}"
          @click="${event => this.handleTileImageClick(project, event)}"
        >
          ${project.src
            ? html`
                <img
                  src="${this.imagebossUrl(project.src, null, '680')}"
                  alt="${project.name || ''}"
                  loading="lazy"
                />
              `
            : html``}
        </a>
        <div class="lisa-tile-caption">
          <h3 class="lisa-tile-title">${project.name}</h3>
          <cta-text
            class="lisa-tile-cta"
            .ctaData=${{ text: 'View Project', url: project.url }}
            .ctaAnalyticsData=${analyticsCtaDataObject(
              {
                text: project.name,
                url: project.url,
                placement: 'Project Gallery Driver',
              },
              'Project Gallery Driver'
            )}
          ></cta-text>
        </div>
      </div>
    `;
  }

  handleTileImageClick(project, event) {
    handleAdobeNavEvent({
      navString: `NAV|Project Gallery Driver|${adobeCleanString(
        project.name || ''
      )}`,
      destinationUrl: project.url,
      event,
    });
  }

  get images() {
    return this.content.images || [];
  }
}
Lisa.defineElement();
